"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _root;
  return {
    root: (_root = {}, _defineProperty(_root, theme.breakpoints.up('md'), {
      padding: theme.spacing(3)
    }), _defineProperty(_root, theme.breakpoints.down('md'), {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3)
    }), _root)
  };
});
var SttPaper = function SttPaper(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Paper["default"], _extends({
    elevation: 0,
    classes: classes
  }, props));
};
var _default = SttPaper;
exports["default"] = _default;